<template>
    <el-form class="mt-20" :inline="true" label-width="75px">
        <div>
            <template v-for="item in fieldArr">
                <el-form-item
                    :class="['multi-search-form-item', `label-${item.name}`]"
                    :key="item.label"
                    :label="item.label"
                >
                    <input-custom v-if="item.mode === 'input'" v-model.trim="ruleForm[item.name]"
                                  placeholder="支持多个，以,或者空格隔开"></input-custom>
                    <el-select
                        size="medium"
                        :ref="`${item.name}Select`"
                        :multiple="item.multiple !== false"
                        v-else-if="item.mode === 'select'"
                        clearable
                        v-model="ruleForm[item.name]"
                        @change="onSelectChange($event, item)"
                        :placeholder="`请选择${item.label}`"
                    >
                        <el-option
                            v-for="subItem in getOptions(item)"
                            :key="subItem.value"
                            :label="subItem.text"
                            :value="subItem.value"
                        />
                    </el-select>
                    <el-date-picker v-else-if="item.mode === 'date'" :type="item.mode" placeholder="请选择时间"
                                    size="medium" 
                                    :editable="false"
                                    format="yyyy-MM-dd"
                                    v-model="ruleForm[item.name]"></el-date-picker>
                    <el-select v-else-if="item.mode==='dept'" v-model="ruleForm[item.name]"
                               filterable
                               remote
                               size="medium" 
                               :multiple="item.multiple !== false"
                               placeholder="请输入关键词"
                               :clearable="true"
                               :remote-method="deptRemoteMethod">
                        <el-option v-for="item in deptArr"
                                   :key="item.deptCode"
                                   :label="item.name"
                                   :value="item.deptCode"></el-option>
                    </el-select>
                    <el-date-picker
                        v-else-if="item.mode === 'daterange'"
                        v-model="ruleForm[item.name]"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="onDateRangeChange($event, item)">
                    </el-date-picker>
                </el-form-item>
            </template>
            <slot></slot>
        </div>
        <el-form-item>
            <span slot="label">&nbsp;</span>
            <el-button class="search-btn" @click="submitForm()" type="primary">搜索</el-button>
            <el-button class="search-btn" @click="clearAll()">清空</el-button>
            <slot name="operation"></slot>
        </el-form-item>
    </el-form>
</template>

<script>
    import InputCustom from 'components/inputCustom'
    import selectMapMixin from 'mixins/selectMapMixin'
    import {dateFormat} from 'modules/tools'
    import { debounce } from 'throttle-debounce'

    const BaseFieldArr = [{
        filter: '',
        label: '姓名',
        mode: 'input',
        name: 'nameSearch'
    }, {
        filter: 'WB_GENDER',
        label: '性别',
        mode: 'select',
        name: 'genderSearch'
    }, {
        filter: '',
        label: '手机号',
        mode: 'input',
        name: 'mobilePhoneSearch'
    }, {
        filter: '',
        label: '身份证号',
        mode: 'input',
        name: 'numberSearch'
    }, {
        filter: '',
        label: '学校名称',
        mode: 'input',
        name: 'schoolSearch'
    }, {
        filter: '',
        label: '邮箱',
        mode: 'input',
        name: 'emailSearch'
    }, {
        filter: '',
        label: '职位名称',
        mode: 'input',
        name: 'positionSearch'
    }, {
        filter: 'WB_POSITION_SEQUENCE_JSON',
        label: '岗位序列',
        mode: 'select',
        multiple: false,
        name: 'sequenceMainSearch'
    }, {
        filter: 'WB_POSITION_SEQUENCE_JSON',
        label: '岗位子序列',
        mode: 'select',
        name: 'sequenceSubSearch',
        formatter: function (rawOptions, ruleForm) {
            const mainSeq = rawOptions.find(({ value }) => ruleForm.sequenceMainSearch === value) || {}
            return mainSeq.list || []
        }
    }, {
        filter: '',
        label: '招聘部门',
        mode: 'dept',
        name: 'deptCodeSearch'
    }, {
        filter: 'WB_SOURCE_FROM',
        label: '招聘来源',
        mode: 'select',
        name: 'sourceFromSearch'
    }, {
        filter: 'WB_RESUME_SOURCE',
        label: '简历来源',
        mode: 'select',
        name: 'resumeResumeSourceSearch'
    }, {
        filter: 'WB_POSITION_CITY',
        label: '应聘城市',
        data: [],
        mode: 'select',
        name: 'cityIds'
    }]
    let fieldArr = BaseFieldArr.map(field => ({ ...field })),
        arrToObj = (arr) => {
            let temp = {}
            arr.forEach(field => {
                temp[field.name] = field.mode === 'daterange' ? [] : ''
            })
            return temp
        }

    export default {
        name: 'multiSearch',
        components: {InputCustom},
        mixins: [selectMapMixin],
        props: {
            mode: {
                type: String,
                default: 'append' // append追加/cover覆盖
            },
            fields: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        data () {
            this.getFieldArr()
            let ruleForm = arrToObj(fieldArr)
            return {
                fieldArr,
                ruleForm,
                deptArr: []
            }
        },
        computed: {
            isExam () {
                return ['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1
            },
            dateRangeFieldsMap () {
                // eslint-disable-next-line
                return this.fieldArr.filter(f => f.mode === 'daterange').reduce((acc, f) => ((acc[f.name] = f), acc), {})
            }
        },
        watch: {
            'ruleForm.sequenceMainSearch': function() {
                this.ruleForm.sequenceSubSearch = []
            }
        },
        methods: {
            deptRemoteMethod (query) {
                if (query !== '') {
                    this.$axios.get('/system/department/seachDep.api', {
                        params: {name: query},
                        'X-loadingOff': true,
                    }).then(res => {
                        this.deptArr = res.result.list
                    })
                }
            },
            submitForm () {
                let query = {}
                Object.keys(this.ruleForm).forEach(key => {
                    query[key] = this.getValueByArr(this.ruleForm[key])
                })
                query = Object.assign({}, this.$parent.searchData, query, {
                    pageIndex: 1,
                    time: Date.now()
                })
                this.$router.push({query})
                // this.$emit('submit', this.ruleForm)
            },
            clearAll () {
                Object.keys(this.ruleForm).forEach(key => {
                    this.ruleForm[key] = Array.isArray(this.ruleForm[key]) ? [] : ''
                })
                this.$emit('clear')
            },
            getFieldArr () {
                if(['resumeList', 'writtenList', 'interviewList', 'paymentList', 'entryList'].indexOf(this.$route.name) === -1) {
                    fieldArr = fieldArr.filter(cv => cv.name !== 'deptCodeSearch')
                }
                if (['interviewList', 'writtenList', 'entryList'].indexOf(this.$route.name) > -1) {
                    fieldArr = fieldArr.concat([{
                        filter: '',
                        label: '笔试成绩',
                        mode: 'input',
                        name: 'scoreSearch'
                    }])
                }
                if(['index'].indexOf(this.$route.name) > -1) {
                    fieldArr.splice(9, 0, {
                        filter: '',
                        label: '招聘部门',
                        mode: 'dept',
                        name: 'deptCodeSearch'
                    })
                }
                fieldArr = fieldArr.concat(this.fields)
                let insertIndex = 0
                fieldArr.forEach((cv, index) => {
                    if(cv.label === '应聘城市') { insertIndex = index + 1 }
                })
                if(insertIndex) {
                    fieldArr.splice(insertIndex, 0, {
                        filter: '',
                        label: '招聘HR',
                        mode: 'input',
                        name: 'employerSearch'
                    }, {
                        filter: '',
                        label: '投递时间',
                        mode: 'daterange',
                        name: 'commitDate',
                    })
                }
                if (this.mode === 'cover') {
                    fieldArr = this.fields
                }
                return fieldArr
            },
            getValueByArr (value) {
                return Array.isArray(value) ? value.join(',') : (Object.prototype.toString.call(value) === '[object Date]' ? dateFormat(value) : value && value.replace(/\s+/g, ',').replace(/,,/g, ','))
            },
            getOptions (item) {
                let options = this.selectMap[item.filter] || []
                if (typeof item.formatter === 'function' && options.length) {
                    options = item.formatter(options, this.ruleForm)
                }
                return options
            },
            onDateRangeChange(value, item) {
                const [ startVal = '', endVal = '' ] = value || []
                const { start, end } = this.getDateRangeKeys(item)
                this.$set(this.ruleForm, start, startVal)
                this.$set(this.ruleForm, end, endVal)
            },
            onSelectChange(value, item) {
                if (item.name === 'statusSearch') {
                    this.$set(this.ruleForm, 'isJobTransfer', value && value.includes('10000') ? '1' : '0')
                }
            },
            getDateRangeKeys(item) {
                const { name, keys } = item
                const [
                    start = `${name}Start`,
                    end = `${name}End`,
                ] = keys || []
                return {
                    start,
                    end
                }
            }
        },
        mounted () {
            Object.keys(this.ruleForm).forEach(key => {
                const value = this.$route.query[key]
                if (value) {
                    this.ruleForm[key] = Array.isArray(this.ruleForm[key]) ? value.split(',') : value
                }
                // 时间范围选择器、简历状态;插入参数与赋值参数值不同步的情况
                if (key in this.dateRangeFieldsMap) {
                    this.onDateRangeChange(this.ruleForm[key], this.dateRangeFieldsMap[key])
                } else if (key === 'statusSearch') {
                    this.onSelectChange(this.ruleForm[key], { name: 'statusSearch' })
                }
            })
            if(this.ruleForm.deptCodeSearch && this.ruleForm.deptCodeSearch.length) {
                this.$axios.get('/system/department/seachDep.api', {
                    params: {deptCodes: this.ruleForm.deptCodeSearch.join(',')},
                    'X-loadingOff': true,
                }).then(res => {
                    this.deptArr = res.result.list
                })
            }
            function detectZoom () {
                var ratio = 0,
                    screen = window.screen,
                    ua = navigator.userAgent.toLowerCase()
            
                if (window.devicePixelRatio !== undefined) {
                    ratio = window.devicePixelRatio
                } else if (~ua.indexOf('msie')) {
                    if (screen.deviceXDPI && screen.logicalXDPI) {
                        ratio = screen.deviceXDPI / screen.logicalXDPI
                    }
                } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
                    ratio = window.outerWidth / window.innerWidth
                }
                
                if (ratio) {
                    ratio = Math.round(ratio * 100)
                }
                
                return ratio
            };
            window.onresize = debounce(2000, function(e) {
                let result = detectZoom()
                if(result < 100) {
                    if(!document.querySelector('#resizestyle')) {
                        let newElement = document.createElement('style')
                        newElement.id = 'resizestyle'
                        newElement.innerHTML = ('.el-form--inline .el-select > .el-input > .el-input__inner {height: 36px !important;}')
                        document.body.appendChild(newElement)
                    }
                }else{
                    if(document.querySelector('#resizestyle')) {
                        document.querySelector('#resizestyle').remove()
                    }
                }
            })
        },
        destroyed () {
            window.onresize = null
        },
        created () {
            fieldArr = BaseFieldArr.map(field => ({ ...field }))
        }
    }
</script>

<style type="text/css" lang="scss">
    .el-form--inline {
        .el-form-item {
            margin-right : 25px;
        }

        .el-form-item__content, .el-select, .el-date-editor.el-input {
            width : 300px;
        }
        .el-select {
            > .el-select__tags {
                > span {
                    line-height : 30px;
                    display     : block;
                    white-space : nowrap;
                    overflow    : auto;
                }
            }
        }
        .el-date-editor{
            width: 300px;
        }
        .search-btn{
            padding: 10px 40px;
            + .search-btn{
                margin-left: 30px;
            }
        }
    }

    .multi-search-form-item {
        .el-form-item__label {
            white-space: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// multiSearch.vue?657c799b